// extracted by mini-css-extract-plugin
export default {"sectionLabel":"section-label_sectionLabel__M9UcS"};